import React from 'react';
import type { MigrationFeatureCardProps } from '../../../../types/migration';

const MigrationFeatureCard: React.FC<MigrationFeatureCardProps> = ({ 
  icon: Icon, 
  name, 
  description 
}) => {
  return (
    <div className="p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <div className="p-2 bg-blue-50 rounded-lg">
            <Icon className="h-6 w-6 text-blue-600" />
          </div>
        </div>
        <div className="ml-4">
          <h4 className="text-lg font-semibold text-gray-900">{name}</h4>
          <p className="mt-1 text-gray-600">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default MigrationFeatureCard;